const unit = {
    0: '원',
    1: '십원',
    2: '백원',
    3: '천원',
    4: '만원',
    5: '십만원',
    6: '백만원',
    7: '천만원',
    8: '억',
    9: '십억',
    10: '백억',
    11: '천억',
    12: '조',
    13: '십조',
    14: '백조',
    15: '천조',
    16: '경',
}

const currencyKr = revenue => {
    const revenueStr = '' + revenue;
    const display = Number(revenueStr.substring(0, 4)).toLocaleString();
    const unitIndex = revenueStr.substring(4).length;

    return `${display} ${unit[unitIndex] || ''}`
};

export {currencyKr};
